import { render, staticRenderFns } from "./SubscriptionsPage.vue?vue&type=template&id=250f5f31&scoped=true"
import script from "./SubscriptionsPage.vue?vue&type=script&lang=js"
export * from "./SubscriptionsPage.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionsPage.vue?vue&type=style&index=0&id=250f5f31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250f5f31",
  null
  
)

export default component.exports